/**
 * Schema.org BreadcrumbList dla SEO
 * Google wyświetla breadcrumby w wynikach wyszukiwania
 */
export function BreadcrumbSchema({ breadcrumbs }) {
  if (!breadcrumbs || breadcrumbs.length === 0) return null;
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((b, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": b.name,
      "item": `https://apisai.pl${b.url}`
    }))
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}
